<template>
  <div class="comp-header">
    <div class="top">
      <div class="g-wrap">
        <router-link class="left" :style="
            'background: url(' +
              require('../assets/img/logo/' + logoSrc + '.png') +
              ') no-repeat;'
          " to="/">{{ $site.name }}</router-link>
        <div class="right">
          <!-- //app下载入口 -->
          <div class="app_download_container" @mouseenter="isShow = true" @mouseleave="isShow = false">
            <i class="iconfont iconappxiazai"></i>
            <span class="download_text">扫码进入小程序</span>
            <i class="el-icon-caret-bottom"></i>
            <div v-show="isShow" id="qrcode" class="div-qr">
              <vue-qr whiteMargin style="width:96px;height:96px;" :logoSrc="downloadData.logo" :logoScale="0.2" :text="downloadData.url" :margin="0" colorDark="#000" colorLight="#fff" :size="96"></vue-qr>
              <div class="app_text">产业学院</div>
            </div>
          </div>
          <el-input v-model="keyword" size="small" @keyup.enter="handleSearch" placeholder="请输入搜索内容">
            <svg-icon icon-class="search" @click="handleSearch" slot="suffix"></svg-icon>
          </el-input>
          <span @click="goAdmin" class="link-manage">
            <svg-icon icon-class="manage"></svg-icon>管理中心
          </span>
          <template v-if="isLogin">
            <div class="dropdown" @mouseleave="hideMenu" @mouseenter="showMenu">
              <span class="dropdown-trigger" @mouseleave="hideMenu" @mouseenter="showMenu">
                <svg-icon icon-class="user"></svg-icon>
                {{ user.userName }}
                <i class="el-icon-arrow-down"></i>
              </span>
              <ul class="dropdown-menu" v-show="showDropMenu">
                <li class="dropdown-menu__item" @click="handleCommand('profile')">
                  个人中心
                </li>
                <li class="dropdown-menu__item" @click="handleCommand('logout')">
                  退出登录
                </li>
              </ul>
            </div>
          </template>
          <template v-else>
            <a href="javascript:void(0)" @click="login">用户登录</a>
            <a class="link-register" href="/register">免费注册</a>
          </template>
        </div>
      </div>
    </div>
    <div class="nav">
      <div class="g-wrap">
        <router-link :to="item.link" v-for="(item, i) in menuList" :key="i">
          {{ item.name }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Mgr from "../services/SecurityService";
import VueQr from "vue-qr";

export default {
  name: "ic-header",
  components: {
    VueQr
  },
  props: {
    menuList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      keyword: "",
      isShow: false,
      isLogin: false,
      user: { userName: "陈大波" },
      showDropMenu: false,
      timer: null,
      userMgr: new Mgr(),
      defaultLogo: "logo-portal", //默认logo图片名称
      downloadData: {
        url: this.$site.appLink,
        logo: require("@/assets/image/QRCode.png")
      }
    };
  },
  computed: {
    logoSrc() {
      let src = this.$route.path.split("/")[1];
      const modulesFiles = require.context(
        "../assets/img/logo",
        false,
        /\.png$/
      );
      const modules = modulesFiles.keys().reduce((modules, modulePath) => {
        const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
        modules[moduleName] = moduleName;
        return modules;
      }, {});
      var logo = "logo-" + src;
      if (modules[logo]) {
        return modules[logo];
      } else {
        return this.defaultLogo;
      }
    }
  },
  created() {
    console.log();
  },
  mounted() {
    this.checkLogin();
  },
  methods: {
    async checkLogin() {
      var that = this;
      var isLogin = await this.userMgr.isLogin();
      this.isLogin = isLogin;
      if (isLogin) {
        this.userMgr
          .getUser()
          .then(user => {
            that.user.userName = user.profile.NickName;
          })
          .catch(err => {
            console.error("getUser", err);
          });
      }
    },
    login() {
      this.userMgr.signIn();
    },
    handleSearch() { },
    hideMenu() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.showDropMenu = false;
      }, 150);
    },
    showMenu() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.showDropMenu = true;
      }, 150);
    },
    handleCommand(cmd) {
      console.warn(cmd);
      if (cmd === "logout") {
        this.userMgr.signOut();
      }
    },
    goAdmin() {
      window.open("/admin/", "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.comp-header {
  .g-wrap {
    display: flex;
    justify-content: space-between;
  }
  .top {
    background-color: $header-color;
    padding: 16px 0;
    .left {
      font-size: 0;
      line-height: 500px;
      // overflow: hidden;
      min-width: 200px;
      width: 386px;
      height: 40px;
    }
    .right {
      font-size: 12px;
      display: flex;
      align-items: center;
      ::v-deep .el-input {
        width: 208px;
        margin-right: 16px;
        position: relative;
        .svg-icon {
          margin: 6px 10px 0 0;
          font-size: 14px;
          vertical-align: top;
          color: $header-font-color;
          cursor: pointer;
        }
        &__inner {
          height: 28px;
          background: rgba(51, 51, 51, 0.1);
          border-radius: 14px;
          color: $header-font-color;
          border: none;
          font-size: 12px;
        }
        @include placeholder($header-font-color);
      }
      a {
        color: $header-font-color;
        &:hover {
          color: $link-active-color;
        }
        &.link-register {
          color: $register-color;
          font-weight: bold;
          padding-left: 5px;
          margin-left: 5px;
          &::before {
            width: 1px;
            height: 11px;
            background-color: #fff;
            content: ' ';
            display: inline-block;
            overflow: hidden;
            margin-right: 7px;
            vertical-align: middle;
          }
          &:hover {
            color: $link-active-color;
          }
        }
      }
      .dropdown {
        font-size: 12px;
        color: $header-font-color;
        white-space: nowrap;
        display: inline-block;
        position: relative;
        z-index: 9;
        cursor: pointer;
        .dropdown-menu {
          position: absolute;
          top: 20px;
          right: 0;
          background-color: $header-font-color;
          color: $header-color;
          padding: 3px 10px;
          line-height: 22px;
          border-radius: 4px;
        }
        .dropdown-trigger {
          .svg-icon {
            vertical-align: middle;
            margin-top: -2px;
            margin-right: 1px;
            font-size: 11px;
          }
        }
        .dropdown-menu__item {
          cursor: pointer;
        }
        .dropdown-menu__item + .dropdown-menu__item {
          border-top: 1px solid #ddd;
          margin-top: 3px;
          padding-top: 3px;
        }
      }
      .app_download_container {
        position: relative;
        cursor: pointer;
        color: $header-font-color;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 16px;
        .download_text {
          margin: 0 4px;
        }
        .div-qr {
          z-index: 99;
          position: absolute;
          background-color: #fff;
          box-shadow: 0px 4px 8px 0px rgba(51, 51, 51, 0.3);
          border-radius: 8px;
          width: 128px;
          height: 156px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          transform: translate(0, 62%);
          .app_text {
            margin-top: 8px;
            color: $baseColor;
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }
  }
  .nav {
    background-color: $header-nav-color;
    .g-wrap {
      height: 40px;
      display: flex;
      align-items: center;
      a {
        display: inline-block;
        color: $header-navfont-color;
        height: 100%;
        display: flex;
        align-items: center;
        padding: 0 20px 0px 20px;
        box-sizing: border-box;
        border-bottom: 2px solid transparent;
        transition: border-bottom-color 0.3s ease;
        &.router-link-exact-active,
        &:hover {
          background-color: $header-nav-check-color;
          border-bottom: 2px solid $header-navbottom-check-color;
          color: $header-navfont-check-color;
        }
      }
    }
  }
}
.link-manage {
  color: $header-font-color;
  cursor: pointer;
  .svg-icon {
    margin-right: 5px;
  }
  margin-right: 15px;
}
</style>
